import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ChevronRightDouble20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M3.46973 15.4697L4.53039 16.5303L11.0607 10L4.53039 3.46968L3.46973 4.53034L8.9394 10L3.46973 15.4697Z'
      fill='currentColor'
    />
    <path
      d='M8.96973 15.4697L10.0304 16.5303L16.5607 10L10.0304 3.46968L8.96973 4.53034L14.4394 10L8.96973 15.4697Z'
      fill='currentColor'
    />
  </Svg>
);

ChevronRightDouble20.displayName = 'ChevronRightDouble20';
export default ChevronRightDouble20;
